import logo from "../assets/images/logo.png";
import "../styles/footer.css";

const Footer = ({ showBranding }) => {
  if (!showBranding) {
    return null;
  }

  return (
    <footer>
      <img src={logo} alt="logo" />
      <a
        href="https://apps.shopify.com/pendora-digital-download"
        target="_blank" rel="noreferrer"
      >
        Powered by <span>Pendora</span>
      </a>
    </footer>
  );
};

export default Footer;
